import axios from 'axios';

export default {
    async create(cartItem) {
        let response = await axios.post('/api/cartItems', cartItem);
        return response.data;
    },
    async update(cartItem) {
        let response = await axios.patch(`/api/cartItems/${cartItem.id}`, cartItem);
        return response.data;
    },
    async delete(cartItem) {
        let response = await axios.delete(`/api/cartItems/${cartItem.id}`);
        return response.data;
    },
    async searchForAmazonProduct(amazonProduct) {
        let response = await axios.get(`/api/cartItems/search/amazonProduct/${amazonProduct.id}`);
        return response.data;
    },
    async getGenericItemSuggestions() {
        let response = await axios.get('/api/cartItems/genericItemSuggestions');
        return response.data;
    },
}
